import React, {useMemo} from 'react'
import Select, {createSelectItem} from "components/Select";
import GridBlock from "components/GridBlock";
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/styles";
import IconButton from "components/button/IconButton";
import ArrowIconLeft from "@material-ui/icons/KeyboardArrowLeft";
import ArrowIconRight from "@material-ui/icons/KeyboardArrowRight";
import {Paper} from "@material-ui/core";
import Button from "../../../Button";
import PlusOneIcon from "@material-ui/icons/PlusOne";
import getObjectValue from "../../../../libs/getObjectValue";

const useStyle = makeStyles(theme => ({
    root: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        top: 162,
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
    },
    paper: {
        border: `solid 2px ${theme.palette.border.dark}`,
        padding: theme.spacing(0.25)
    },
    select: {
        minWidth: 250
    },
    margin: {
        margin: `0 ${theme.spacing()}px`
    }
}))

function DealingsNavigator(
    {
        formikProps,
        id,
        items,
        addPart
    }) {
    const classes = useStyle();
    const editable = getObjectValue('_editable', formikProps.values, true);
    const passive = getObjectValue('_passive', formikProps.values, false);
    const onlyNotice = getObjectValue('_onlyNotice', formikProps.values, false);
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    // eslint-disable-next-line
    const memoItems = useMemo(() => {
        const arr = items.map((x, i, arr) => createSelectItem(i, Tr("part_x", {x: i + 1})));
        arr.unshift(createSelectItem(-1, Tr('choose_position')));
        return arr;
    }, [items])

    const curIndex = formikProps.values[id];

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <GridBlock justify="space-evenly" alignItems="center">
                    <GridBlock justify="center" alignItems="center">
                        <IconButton
                            className={classes.margin}
                            disabled={curIndex < 0}
                            tooltip={curIndex > -1 ? Tr("part_x", {x: curIndex}) : Tr('select')}
                            variant="outlined"
                            onClick={() => formikProps.setFieldValue(id, curIndex - 1)}
                            Icon={ArrowIconLeft}/>
                        <Select className={classes.select} formikProps={formikProps} id={id} items={memoItems} noError alwaysEditable/>
                        <IconButton
                            className={classes.margin}
                            disabled={curIndex === items.length - 1}
                            tooltip={curIndex < items.length - 1 ? Tr("part_x", {x: curIndex + 2}) : undefined}
                            variant="outlined"
                            onClick={() => formikProps.setFieldValue(id, curIndex + 1)}
                            Icon={ArrowIconRight}/>
                    </GridBlock>
                    {(onlyNotice || passive) && !!addPart && <Button Icon={PlusOneIcon} onClick={addPart} disabled={updateNotice || !editable}>{Tr('add_part')}</Button>}
                </GridBlock>
            </Paper>
        </div>)
}

DealingsNavigator.propTypes = {};

export default DealingsNavigator;
